<div class="content-block">
  <app-calculator-us-remastered></app-calculator-us-remastered>
</div>
